// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "legends-o4wPr";
var _5 = "money-23I4B";
var _6 = "legendsWrapper-1erEc";
var _7 = "line-2ERqW";
var _8 = "label-3uXfV";
var _9 = "line_min-Sfeq7";
var _a = "line_max-VAk48";
var _b = "line_bottom-2jPj_";
var _c = "zero-2RIG1";
var _d = "average-oF88p";
var _e = "max-2O3UH";
var _f = "label__text-346wV";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "legends", _5 as "money", _6 as "legendsWrapper", _7 as "line", _8 as "label", _9 as "line_min", _a as "line_max", _b as "line_bottom", _c as "zero", _d as "average", _e as "max", _f as "label__text" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "legends": _4, "money": _5, "legendsWrapper": _6, "line": _7, "label": _8, "line_min": _9, "line_max": _a, "line_bottom": _b, "zero": _c, "average": _d, "max": _e, "label__text": _f }
